import React from "react";

export const LampIcon = ({
  width = "17.5",
  height = "30",
  fill = "#89ab0d",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 17.5 30"
      {...{ width, height, fill }}
    >
      <path
        id="iconmonstr-light-bulb-19"
        d="M22.5,8.418c0,5.84-5.312,8.849-5.312,15.332H10.313C10.313,17.266,5,14.257,5,8.418,5,2.989,9.373,0,13.745,0S22.5,2.993,22.5,8.418ZM16.563,25H10.938a.625.625,0,0,0,0,1.25h5.625a.625.625,0,0,0,0-1.25Zm.313,2.5h-6.25l1.814,2.074A1.254,1.254,0,0,0,13.38,30h.741a1.251,1.251,0,0,0,.94-.426L16.875,27.5Z"
        transform="translate(-5)"
      />
    </svg>
  );
};
